import React from 'react'
import ReactDom from 'react-dom'
import { Provider } from 'react-redux'
import { ConfigProvider, message } from 'antd'
import { ConnectedRouter } from 'connected-react-router/immutable'
import moment from 'moment'
import 'moment/locale/zh-cn'
import zhCN from 'antd/es/locale/zh_CN'
import store, { history } from './store'
import Route from './routes'
import './styles/main.less'

// 初始化配置message只出现一个
message.config({
  maxCount: 1
})

moment.locale('zh-cn')

// 设置Select 等父级偏移，可根据项目单独配置
const popupContainer = () => {
  return document.getElementById('container')
}

const App = (
  <ConfigProvider getPopupContainer={popupContainer} locale={zhCN}>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Route />
      </ConnectedRouter>
    </Provider>
  </ConfigProvider>
)

if (process.env.NODE_ENV !== 'production') {
  if (module.hot) {
    module.hot.accept()
  }
}

ReactDom.render(App, document.getElementById('main'))
